import ExpenseEditForm from "../../Components/Expenses/ExpenseEditForm";

function ExpenseEdit() {
  return (
    <div>
      <ExpenseEditForm />
    </div>
  );
}

export default ExpenseEdit;
